import { Button, Group, Modal, ThemeIcon } from "@mantine/core";
import { useState } from "react";
import OvhContent from "./OvhContent";
import { useLanguage } from "../../../../stores/LanguageStore";
import { IconBuildingStore } from "@tabler/icons-react";
import { useSessionStore } from "../../../../stores/UserStore";

const OvhDomain = ({ onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <>
      <Button
        size="md"
        onClick={handleOpen}
        leftSection={<IconBuildingStore />}
      >
        {lang.ovh.button_label}
      </Button>

      <Modal
        title={
          <Group fz={16}>
            <ThemeIcon variant="subtle" color="black" size={"lg"}>
              <IconBuildingStore />
            </ThemeIcon>
            {lang.ovh.dialog_title}
          </Group>
        }
        opened={opened}
        onClose={handleClose}
        styles={{
          title: {
            lineHeight: 1.5,
          },
        }}
        size={useSessionStore.getState().reseller?.name === "Magileads" ? "90%" : "75%"}
      >
        <OvhContent handleClose={handleClose} onFinish={onFinish} />
      </Modal>
    </>
  );
};

export default OvhDomain;
